<script>
export default {
  data() {
    return {
      savedLocations: [],
      state: "new",
    };
  },
  methods: {
    changeState: function (newState) {
      this.state = newState;
    },
  },
  computed: {
    newItems() {
      return this.$store.getters.loadedItems.filter(
        (item) => item.status !== "pending-review"
      );
    },
    DIYItems() {
      return this.newItems.filter((item) => item.category === "DIY");
    },
    transportItems() {
      return this.newItems.filter((item) => item.category === "Transportation");
    },
    exerciseItems() {
      return this.newItems.filter((item) => item.category === "Exercise");
    },
    householdItems() {
      return this.newItems.filter(
        (item) => item.category === "Household living"
      );
    },
    musicItems() {
      return this.newItems.filter(
        (item) => item.category === "Music and Audio"
      );
    },
    techItems() {
      return this.newItems.filter((item) => item.category === "Technology");
    },
  },
};
</script>

<template>
  <v-container class="pt-5 mb-5">
    <h4
      v-if="this.$route.name !== 'Home 🏠'"
      :class="[$vuetify.breakpoint.mdAndUp ? 'headline' : 'headline']"
      class="font-weight-regular"
    >
      Explore our categories
    </h4>

    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center mb-5">
          <v-slide-group class="ml-n5 mb-3">
            <v-slide-item>
              <v-btn
                class="mx-2 px-2"
                small
                depressed
                :color="state === 'new' ? 'secondary lighten-3' : ''"
                rounded
                @click="changeState('new')"
              >
                <v-img
                  class="mr-2"
                  height="25px"
                  width="25px"
                  :src="require('@/assets/fontawesome/sparkles-duotone.svg')"
                ></v-img>
                New
              </v-btn>
            </v-slide-item>
            <v-slide-item>
              <v-btn
                class="mx-2"
                small
                :color="state === 'transport' ? 'secondary lighten-3' : ''"
                depressed
                rounded
                @click="changeState('transport')"
              >
                <v-img
                  class="mr-2"
                  height="25px"
                  width="25px"
                  :src="require('@/assets/fontawesome/moped-duotone.svg')"
                ></v-img>
                Transport
              </v-btn>
            </v-slide-item>
            <v-slide-item>
              <v-btn
                class="mx-2"
                small
                depressed
                :color="state === 'DIY' ? 'secondary lighten-3' : ''"
                rounded
                @click="changeState('DIY')"
              >
                <v-img
                  class="mr-2"
                  height="20px"
                  width="20px"
                  :src="
                    require('@/assets/fontawesome/screwdriver-wrench-duotone.svg')
                  "
                ></v-img>
                DIY
              </v-btn>
            </v-slide-item>
            <v-slide-item>
              <v-btn
                class="mx-2"
                small
                :color="state === 'exercise' ? 'secondary lighten-3' : ''"
                active-class="purple white--text"
                depressed
                rounded
                @click="changeState('exercise')"
              >
                <v-img
                  class="mr-2"
                  height="25px"
                  width="25px"
                  :src="require('@/assets/fontawesome/dumbbell-duotone.svg')"
                ></v-img>
                Exercise
              </v-btn>
            </v-slide-item>
            <v-slide-item>
              <v-btn
                class="mx-2"
                small
                depressed
                :color="state === 'household' ? 'secondary lighten-3' : ''"
                rounded
                @click="changeState('household')"
              >
                <v-img
                  class="mr-2"
                  height="25px"
                  width="25px"
                  :src="require('@/assets/fontawesome/house-heart-duotone.svg')"
                ></v-img>
                Household Living
              </v-btn>
            </v-slide-item>
            <v-slide-item>
              <v-btn
                class="mx-2"
                small
                :color="state === 'music' ? 'secondary lighten-3' : ''"
                depressed
                rounded
                @click="changeState('music')"
              >
                <v-img
                  class="mr-2"
                  height="25px"
                  width="25px"
                  :src="require('@/assets/fontawesome/speakers-duotone.svg')"
                ></v-img>
                Music and Audio
              </v-btn>
            </v-slide-item>
            <v-slide-item>
              <v-btn
                class="mx-2"
                small
                :color="state === 'tech' ? 'secondary lighten-3' : ''"
                depressed
                rounded
                @click="changeState('tech')"
              >
                <v-img
                  class="mr-2"
                  height="25px"
                  width="25px"
                  :src="
                    require('@/assets/fontawesome/laptop-mobile-duotone.svg')
                  "
                ></v-img>
                Technology
              </v-btn>
            </v-slide-item>
          </v-slide-group>
        </div>

        <div class="d-flex justify-center">
          <template v-if="state === 'new'">
            <v-row class="mx-auto" style="max-width: 1094px">
              <v-col
                v-for="item in newItems.slice(0, 7)"
                :key="item.id"
                style="cursor: pointer"
                cols="6"
                sm="4"
                md="3"
              >
                <div
                  class="item"
                  @click="
                    $router.push('/items/' + item.itemName.replace(/\s+/g, '-'))
                  "
                >
                  <v-card
                    :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                    :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                    style="border-radius: 12px"
                  >
                    <v-img
                      cover
                      :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                      :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                      :src="item.images ? item.images[0] : ''"
                    />
                  </v-card>
                  <v-row
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 230px;'
                        : 'max-width: 250px;'
                    "
                    class="font-weight-light text-body-2 px-3 mt-1"
                  >
                    <span class="mr-3">{{ item.created_by }}</span>
                    <v-spacer></v-spacer>
                    <span>{{ item.area }}</span>
                  </v-row>

                  <div
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 200px;'
                        : 'max-width: 250px;'
                    "
                    class="text-truncate text-body-2 black--text mb-0 mt-2"
                  >
                    {{ item.itemName }}
                  </div>

                  <v-row
                    class="ml-auto mr-auto"
                    style="max-width: 250px; margin-top: 5px !important"
                  >
                    <p class="secondary--text text-body-2">
                      R{{ item.dailyFee }} p/day
                    </p>
                    <v-spacer></v-spacer>
                    <template v-if="item.rating_count >= 1">
                      <p class="text-body-2">
                        {{ Math.round(item.rating * 100) / 100 }}
                      </p>

                      <svg
                        aria-hidden="true"
                        height="20px"
                        width="20px"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="star"
                        class="svg-inline--fa fa-star mx-1"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="gold"
                            d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                          ></path>
                          <path class="fa-primary" fill="gold" d=""></path>
                        </g>
                      </svg>

                      <p class="grey--text text-body-2">
                        ({{ item.rating_count }})
                      </p>
                    </template>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="6" sm="4" md="3">
                <div class="ma-1 item" to="/search">
                  <v-card
                    style="cursor: pointer; border-radius: 12px"
                    class="ma-2 item card grid"
                    height="200px"
                    outlined
                    to="/search"
                    width="250px"
                  >
                    <p class="text-caption text-md-body-1">
                      View More listings
                    </p>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </template>

          <template v-if="state === 'DIY'">
            <v-row class="mx-auto" style="max-width: 1094px">
              <v-col
                v-for="item in DIYItems.slice(0, 7)"
                :key="item.id"
                style="cursor: pointer"
                cols="6"
                sm="4"
                md="3"
              >
                <div
                  class="item"
                  @click="
                    $router.push('/items/' + item.itemName.replace(/\s+/g, '-'))
                  "
                >
                  <v-card
                    :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                    :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                    style="border-radius: 12px"
                  >
                    <v-img
                      :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                      :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                      :src="item.images ? item.images[0] : ''"
                    />
                  </v-card>
                  <v-row
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 230px;'
                        : 'max-width: 250px;'
                    "
                    class="font-weight-light text-body-2 px-3 mt-1"
                  >
                    <span class="mr-3">{{ item.created_by }}</span>
                    <v-spacer></v-spacer>
                    <span>{{ item.area }}</span>
                  </v-row>

                  <div
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 200px;'
                        : 'max-width: 250px;'
                    "
                    class="text-truncate text-body-2 black--text mb-0 mt-2"
                  >
                    {{ item.itemName }}
                  </div>

                  <v-row
                    class="ml-auto mr-auto"
                    style="max-width: 250px; margin-top: 5px !important"
                  >
                    <p class="secondary--text text-body-2">
                      R{{ item.dailyFee }} p/day
                    </p>
                    <v-spacer></v-spacer>
                    <template v-if="item.rating_count >= 1">
                      <p class="text-body-2">
                        {{ Math.round(item.rating * 100) / 100 }}
                      </p>

                      <svg
                        aria-hidden="true"
                        height="20px"
                        width="20px"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="star"
                        class="svg-inline--fa fa-star mx-1"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="gold"
                            d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                          ></path>
                          <path class="fa-primary" fill="gold" d=""></path>
                        </g>
                      </svg>

                      <p class="grey--text text-body-2">
                        ({{ item.rating_count }})
                      </p>
                    </template>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="6" sm="4" md="3">
                <div class="ma-1 item" to="/Items">
                  <v-card
                    style="cursor: pointer; border-radius: 12px"
                    class="ma-2 item card grid"
                    height="200px"
                    outlined
                    to="/Items"
                    width="250px"
                  >
                    <p class="text-caption text-md-body-1">
                      View More listings
                    </p>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </template>

          <template v-if="state === 'transport'">
            <v-row class="mx-auto" style="max-width: 1094px">
              <v-col
                v-for="item in transportItems.slice(0, 7)"
                :key="item.id"
                style="cursor: pointer"
                cols="6"
                sm="4"
                md="3"
              >
                <div
                  class="item"
                  @click="
                    $router.push('/items/' + item.itemName.replace(/\s+/g, '-'))
                  "
                >
                  <v-card
                    :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                    :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                    style="border-radius: 12px"
                  >
                    <v-img
                      :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                      :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                      :src="item.images ? item.images[0] : ''"
                    />
                  </v-card>
                  <v-row
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 230px;'
                        : 'max-width: 250px;'
                    "
                    class="font-weight-light text-body-2 px-3 mt-1"
                  >
                    <span class="mr-3">{{ item.created_by }}</span>
                    <v-spacer></v-spacer>
                    <span>{{ item.area }}</span>
                  </v-row>

                  <div
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 200px;'
                        : 'max-width: 250px;'
                    "
                    class="text-truncate text-body-2 black--text mb-0 mt-2"
                  >
                    {{ item.itemName }}
                  </div>

                  <v-row
                    class="ml-auto mr-auto"
                    style="max-width: 250px; margin-top: 5px !important"
                  >
                    <p class="secondary--text text-body-2">
                      R{{ item.dailyFee }} p/day
                    </p>
                    <v-spacer></v-spacer>
                    <template v-if="item.rating_count >= 1">
                      <p class="text-body-2">
                        {{ Math.round(item.rating * 100) / 100 }}
                      </p>

                      <svg
                        aria-hidden="true"
                        height="20px"
                        width="20px"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="star"
                        class="svg-inline--fa fa-star mx-1"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="gold"
                            d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                          ></path>
                          <path class="fa-primary" fill="gold" d=""></path>
                        </g>
                      </svg>

                      <p class="grey--text text-body-2">
                        ({{ item.rating_count }})
                      </p>
                    </template>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="6" sm="4" md="3">
                <div class="ma-1 item" to="/Items">
                  <v-card
                    style="cursor: pointer; border-radius: 12px"
                    class="ma-2 item card grid"
                    height="200px"
                    outlined
                    to="/Items"
                    width="250px"
                  >
                    <p class="text-caption text-md-body-1">
                      View More listings
                    </p>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </template>

          <template v-if="state === 'exercise'">
            <v-row class="mx-auto" style="max-width: 1094px">
              <v-col
                v-for="item in exerciseItems.slice(0, 7)"
                :key="item.id"
                style="cursor: pointer"
                cols="6"
                sm="4"
                md="3"
              >
                <div
                  class="item"
                  @click="
                    $router.push('/items/' + item.itemName.replace(/\s+/g, '-'))
                  "
                >
                  <v-card
                    :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                    :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                    style="border-radius: 12px"
                  >
                    <v-img
                      :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                      :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                      :src="item.images ? item.images[0] : ''"
                    />
                  </v-card>
                  <v-row
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 230px;'
                        : 'max-width: 250px;'
                    "
                    class="font-weight-light text-body-2 px-3 mt-1"
                  >
                    <span class="mr-3">{{ item.created_by }}</span>
                    <v-spacer></v-spacer>
                    <span>{{ item.area }}</span>
                  </v-row>

                  <div
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 200px;'
                        : 'max-width: 250px;'
                    "
                    class="text-truncate text-body-2 black--text mb-0 mt-2"
                  >
                    {{ item.itemName }}
                  </div>

                  <v-row
                    class="ml-auto mr-auto"
                    style="max-width: 250px; margin-top: 5px !important"
                  >
                    <p class="secondary--text text-body-2">
                      R{{ item.dailyFee }} p/day
                    </p>
                    <v-spacer></v-spacer>
                    <template v-if="item.rating_count >= 1">
                      <p class="text-body-2">
                        {{ Math.round(item.rating * 100) / 100 }}
                      </p>

                      <svg
                        aria-hidden="true"
                        height="20px"
                        width="20px"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="star"
                        class="svg-inline--fa fa-star mx-1"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="gold"
                            d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                          ></path>
                          <path class="fa-primary" fill="gold" d=""></path>
                        </g>
                      </svg>

                      <p class="grey--text text-body-2">
                        ({{ item.rating_count }})
                      </p>
                    </template>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="6" sm="4" md="3">
                <div class="ma-1 item" to="/Items">
                  <v-card
                    style="cursor: pointer; border-radius: 12px"
                    class="ma-2 item card grid"
                    height="200px"
                    outlined
                    to="/Items"
                    width="250px"
                  >
                    <p class="text-caption text-md-body-1">
                      View More listings
                    </p>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </template>

          <template v-if="state === 'household'">
            <v-row class="mx-auto" style="max-width: 1094px">
              <v-col
                v-for="item in householdItems.slice(0, 7)"
                :key="item.id"
                style="cursor: pointer"
                cols="6"
                sm="4"
                md="3"
              >
                <div
                  class="item"
                  @click="
                    $router.push('/items/' + item.itemName.replace(/\s+/g, '-'))
                  "
                >
                  <v-card
                    :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                    :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                    style="border-radius: 12px"
                  >
                    <v-img
                      :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                      :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                      :src="item.images ? item.images[0] : ''"
                    />
                  </v-card>
                  <v-row
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 230px;'
                        : 'max-width: 250px;'
                    "
                    class="font-weight-light text-body-2 px-3 mt-1"
                  >
                    <span class="mr-3">{{ item.created_by }}</span>
                    <v-spacer></v-spacer>
                    <span>{{ item.area }}</span>
                  </v-row>

                  <div
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 200px;'
                        : 'max-width: 250px;'
                    "
                    class="text-truncate text-body-2 black--text mb-0 mt-2"
                  >
                    {{ item.itemName }}
                  </div>

                  <v-row
                    class="ml-auto mr-auto"
                    style="max-width: 250px; margin-top: 5px !important"
                  >
                    <p class="secondary--text text-body-2">
                      R{{ item.dailyFee }} p/day
                    </p>
                    <v-spacer></v-spacer>
                    <template v-if="item.rating_count >= 1">
                      <p class="text-body-2">
                        {{ Math.round(item.rating * 100) / 100 }}
                      </p>

                      <svg
                        aria-hidden="true"
                        height="20px"
                        width="20px"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="star"
                        class="svg-inline--fa fa-star mx-1"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="gold"
                            d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                          ></path>
                          <path class="fa-primary" fill="gold" d=""></path>
                        </g>
                      </svg>

                      <p class="grey--text text-body-2">
                        ({{ item.rating_count }})
                      </p>
                    </template>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="6" sm="4" md="3">
                <div class="ma-1 item" to="/Items">
                  <v-card
                    style="cursor: pointer; border-radius: 12px"
                    class="ma-2 item card grid"
                    height="200px"
                    outlined
                    to="/Items"
                    width="250px"
                  >
                    <p class="text-caption text-md-body-1">
                      View More listings
                    </p>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </template>

          <template v-if="state === 'music'">
            <v-row class="mx-auto" style="max-width: 1094px">
              <v-col
                v-for="item in musicItems.slice(0, 7)"
                :key="item.id"
                style="cursor: pointer"
                cols="6"
                sm="4"
                md="3"
              >
                <div
                  class="item"
                  @click="
                    $router.push('/items/' + item.itemName.replace(/\s+/g, '-'))
                  "
                >
                  <v-card
                    :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                    :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                    style="border-radius: 12px"
                  >
                    <v-img
                      :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                      :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                      :src="item.images ? item.images[0] : ''"
                    />
                  </v-card>
                  <v-row
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 230px;'
                        : 'max-width: 250px;'
                    "
                    class="font-weight-light text-body-2 px-3 mt-1"
                  >
                    <span class="mr-3">{{ item.created_by }}</span>
                    <v-spacer></v-spacer>
                    <span>{{ item.area }}</span>
                  </v-row>

                  <div
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 200px;'
                        : 'max-width: 250px;'
                    "
                    class="text-truncate text-body-2 black--text mb-0 mt-2"
                  >
                    {{ item.itemName }}
                  </div>

                  <v-row
                    class="ml-auto mr-auto"
                    style="max-width: 250px; margin-top: 5px !important"
                  >
                    <p class="secondary--text text-body-2">
                      R{{ item.dailyFee }} p/day
                    </p>
                    <v-spacer></v-spacer>
                    <template v-if="item.rating_count >= 1">
                      <p class="text-body-2">
                        {{ Math.round(item.rating * 100) / 100 }}
                      </p>

                      <svg
                        aria-hidden="true"
                        height="20px"
                        width="20px"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="star"
                        class="svg-inline--fa fa-star mx-1"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="gold"
                            d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                          ></path>
                          <path class="fa-primary" fill="gold" d=""></path>
                        </g>
                      </svg>

                      <p class="grey--text text-body-2">
                        ({{ item.rating_count }})
                      </p>
                    </template>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="6" sm="4" md="3">
                <div class="ma-1 item" to="/Items">
                  <v-card
                    style="cursor: pointer; border-radius: 12px"
                    class="ma-2 item card grid"
                    height="200px"
                    outlined
                    to="/Items"
                    width="250px"
                  >
                    <p class="text-caption text-md-body-1">
                      View More listings
                    </p>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </template>

          <template v-if="state === 'tech'">
            <v-row class="mx-auto" style="max-width: 1094px">
              <v-col
                v-for="item in techItems.slice(0, 7)"
                :key="item.id"
                style="cursor: pointer"
                cols="6"
                sm="4"
                md="3"
              >
                <div
                  class="item"
                  @click="
                    $router.push('/items/' + item.itemName.replace(/\s+/g, '-'))
                  "
                >
                  <v-card
                    :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                    :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                    style="border-radius: 12px"
                  >
                    <v-img
                      :height="$vuetify.breakpoint.smAndDown ? '200' : '200'"
                      :width="$vuetify.breakpoint.smAndDown ? '250' : '250'"
                      :src="item.images ? item.images[0] : ''"
                    />
                  </v-card>
                  <v-row
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 230px;'
                        : 'max-width: 250px;'
                    "
                    class="font-weight-light text-body-2 px-3 mt-1"
                  >
                    <span class="mr-3">{{ item.created_by }}</span>
                    <v-spacer></v-spacer>
                    <span>{{ item.area }}</span>
                  </v-row>

                  <div
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 200px;'
                        : 'max-width: 250px;'
                    "
                    class="text-truncate text-body-2 black--text mb-0 mt-2"
                  >
                    {{ item.itemName }}
                  </div>

                  <v-row
                    class="ml-auto mr-auto"
                    style="max-width: 250px; margin-top: 5px !important"
                  >
                    <p class="secondary--text text-body-2">
                      R{{ item.dailyFee }} p/day
                    </p>
                    <v-spacer></v-spacer>
                    <template v-if="item.rating_count >= 1">
                      <p class="text-body-2">
                        {{ Math.round(item.rating * 100) / 100 }}
                      </p>

                      <svg
                        aria-hidden="true"
                        height="20px"
                        width="20px"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="star"
                        class="svg-inline--fa fa-star mx-1"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="gold"
                            d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                          ></path>
                          <path class="fa-primary" fill="gold" d=""></path>
                        </g>
                      </svg>

                      <p class="grey--text text-body-2">
                        ({{ item.rating_count }})
                      </p>
                    </template>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="6" sm="4" md="3">
                <div class="ma-1 item" to="/Items">
                  <v-card
                    style="cursor: pointer; border-radius: 12px"
                    class="ma-2 item card grid"
                    height="200px"
                    outlined
                    to="/Items"
                    width="250px"
                  >
                    <p class="text-caption text-md-body-1">
                      View More listings
                    </p>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </template>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.grid {
  display: grid;
  place-items: center;
}
.clip {
  text-overflow: clip;
  white-space: nowrap;
  overflow: hidden;
}
.card {
  border-color: rgb(221, 221, 221);
}
.card:hover {
  border-color: rgb(34, 34, 34);
}
.itmcrd {
  transition: opacity 0s ease-in-out;
}
.itmcrd:hover {
  opacity: 0.8;
}
</style>
